import {
  Box,
  Flex,
  Icon,
  Text,
} from "@chakra-ui/react";
import { BsCloudUpload, BsLink45Deg } from "react-icons/bs";
import DataSourcesField from "../../Assistants/DataSourcesField";

const UploadZone = ({ icon, label, onClick }) => (
  <Box
    border="2px dashed"
    borderColor="gray.200"
    borderRadius="lg"
    py={8}
    textAlign="center"
    cursor="pointer"
    _hover={{ borderColor: "blue.300", bg: "blue.50" }}
    transition="all 0.15s"
    onClick={onClick}
  >
    <Icon as={icon} boxSize={8} color="gray.400" mb={2} />
    <Text fontSize="sm" color="gray.500">{label}</Text>
  </Box>
);

const KnowledgeTab = ({ assistantId }) => {
  return (
    <Flex direction="column" gap={4}>
      {/* Upload zones */}
      <UploadZone
        icon={BsCloudUpload}
        label="Upload Document (PDF / CSV)"
      />
      <UploadZone
        icon={BsLink45Deg}
        label="Scrape Website URL"
      />

      {/* Active data sources */}
      {assistantId && (
        <Box mt={2}>
          <DataSourcesField assistantId={assistantId} />
        </Box>
      )}
    </Flex>
  );
};

export default KnowledgeTab;
